module.exports = __webpack_public_path__ + "static/img/no_premise.1e44c8893a10e8f95e0202af0a951a55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/no_premise.png
// module id = mrR3
// module chunks = 14